import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { get } from 'lodash';
import { supportTranslationCountryConvertMap } from '../../../constants/country';
import { resources } from '../../../locales';
export var DEFAULT_PORTAL_INTRO_INFO = {
  brokerName: 'Jove',
  heroTitle: 'Commercial Combined Business Insurance Made Simple - Instant, Digital, Borderless.',
  heroSubtitle: 'We deliver insurance solutions designed for speed and clarity. Instant quotes, digital-first documentation, and borderless capabilities let your clients operate with confidence across markets.',
  heroChecklist: ['Supports companies up to a £100 million turnover', '9 covers in one policy', '90 secs or less to quote and bind'],
  heroImageUrl: 'https://storage.googleapis.com/jove-public-images/website/landing-pages/universal/introduction-broker-work-computer.png',
  coverageTitle: 'Insurance That Covers Every Aspect of Your Business',
  coverageSubtitle: 'Coverage extends worldwide, with optional protection for claims brought in US and Canadian courts — ideal for clients with international operations.',
  coverageItems: [{
    iconName: 'TravelExploreOutlined',
    title: 'Professional Indemnity',
    desc: 'Protection against claims of professional negligence, errors, or omissions — globally.'
  }, {
    iconName: 'Bolt',
    title: 'Public Liability',
    desc: 'Covers third-party injury or property damage from your operations.'
  }, {
    iconName: 'AssignmentIndOutlined',
    title: "Employers' Liability",
    desc: 'Mandatory protection for employees and contractors under UK and EU law.'
  }, {
    iconName: 'SupervisorAccountOutlined',
    title: 'Directors & Officers',
    desc: 'Safeguards directors and key decision-makers from personal liability.'
  }, {
    iconName: 'Domain',
    title: 'Employment Practices Liability',
    desc: 'Covers claims arising from wrongful termination, discrimination, or harassment.'
  }, {
    iconName: 'CommuteOutlined',
    title: 'Drivers Negligence',
    desc: 'Specialised cover for recruitment and umbrella firms supplying drivers.'
  }, {
    iconName: 'LocalPoliceOutlined',
    title: 'Crime Cover',
    desc: 'Protects your business from internal or external fraud and theft.'
  }, {
    iconName: 'MonetizationOnOutlined',
    title: 'Money & Assault Cover',
    desc: 'Protection against theft, robbery, or assault-related loss.'
  }, {
    iconName: 'Computer',
    title: 'Computer Breakdown',
    desc: 'Covers repair or replacement of systems critical to your operations.'
  }],
  expertiseTitle: 'Areas of expertise',
  expertiseChips: [{
    text: 'Technology & SaaS'
  }, {
    text: 'Management Consultant'
  }, {
    text: 'Financial Services'
  }, {
    text: 'Engineering'
  }, {
    text: 'E-commerce & Retail'
  }],
  portalTitle: 'Everything You Need to Place Commercial Combined insurance, in One Portal',
  portalFeatures: [{
    title: 'Instant online quotes and policies',
    desc: 'Documents are generated and issued immediately.',
    imageUrl: 'https://storage.googleapis.com/jove-public-images/website/landing-pages/broker-landing-portal-image1.png'
  }, {
    title: 'Jove Broker Portal',
    desc: 'Including full broker dashboard and quote management',
    imageUrl: 'https://storage.googleapis.com/jove-public-images/website/landing-pages/broker-landing-portal-image2.png'
  }, {
    title: 'Competitive commissions',
    desc: 'For both new and renewing business',
    imageUrl: 'https://storage.googleapis.com/jove-public-images/website/landing-pages/broker-landing-portal-image3.png'
  }, {
    title: 'Borderless insurance policies',
    desc: 'Covering over 250 occupations.',
    imageUrl: 'https://storage.googleapis.com/jove-public-images/website/landing-pages/broker-landing-portal-image4.png'
  }, {
    title: 'Flexible policy structures',
    desc: 'Our policies are available both monthly or annually',
    imageUrl: 'https://storage.googleapis.com/jove-public-images/website/landing-pages/broker-landing-portal-image5.png'
  }],
  advantageTitle: 'We position you to win more client contracts',
  advantageItems: [{
    iconName: 'SlowMotionVideo',
    title: 'Fully automated insurance quoting',
    desc: 'Instant policy documents issued in minutes, letting you close sales quickly while avoiding delays caused by manual underwriting.'
  }, {
    iconName: 'VerifiedUser',
    title: 'Insurance cover across the UK and Europe',
    desc: 'Access instant policy documents that accelerate sales and remove bottlenecks linked to manual underwriting processes.'
  }, {
    iconName: 'Language',
    title: 'Policies issued in multiple local languages',
    desc: 'Instant policy documents issued in minutes, letting you close sales quickly while avoiding delays caused by manual underwriting.'
  }, {
    iconName: 'Analytics',
    title: 'Streamlined broker access via custom portals',
    desc: 'Access instant policy documents that accelerate sales and remove bottlenecks linked to manual underwriting processes.'
  }],
  ctaTitle: 'Ready to start quoting?',
  ctaSubtitle: "Log in if you're already set up, or request access to join {brokerName}'s sub-broker network.",
  resourcesTitle: 'Resources for {brokerName} sub-brokers',
  resourcesSubtitle: 'Everything you need to introduce Business Insurance to your clients.',
  resourceItems: [{
    title: 'How to find your partners & Clients?',
    type: 'PDF',
    url: 'https://storage.googleapis.com/jove-public-images/website/broker/SpecialInsurance_How_to_find_clients_localagent_EN.pdf'
  }, {
    title: 'How to Quote and Bind?',
    type: 'PDF',
    url: 'https://storage.googleapis.com/jove-public-images/website/broker/SpecialInsurance_QuoteandBuyJourney_EU_EN_.pdf'
  }, {
    title: 'Appetite Guide',
    type: 'PDF',
    url: 'https://storage.googleapis.com/jove-public-images/website/broker/SpecialInsurance_Trades_Education_EU_EN.pdf'
  }],
  faqTitle: 'Frequently asked questions',
  faqItems: [{
    question: 'How do I get access to the portal?',
    answer: "Existing sub-brokers can log in directly. If you're new to {brokerName}'s network, register below \u2014 most requests are reviewed and approved within 2 business days."
  }, {
    question: 'What do I need to login as a sub-broker?',
    answer: 'Just your business details and contact information. {brokerName} will review your application and confirm access within 2 business days.'
  }, {
    question: 'How quickly are documents issued?',
    answer: 'Documents are available as soon as you bind your policy.'
  }, {
    question: 'What do I need to register as a sub-broker?',
    answer: 'You only need to provide your business and contact details. Once your application is approved, you will receive access to the portal.'
  }, {
    question: 'How quickly are policy documents issued?',
    answer: 'Policy documents are available as soon as the policy is bound, helping you provide clients with their documents without unnecessary delays.'
  }, {
    question: 'Do I keep ownership of my client?',
    answer: 'Yes. You remain at the centre of the client relationship throughout the quote and placement journey.'
  }, {
    question: 'How quickly can I get a quote?',
    answer: 'Eligible risks can be quoted in seconds, helping you respond while the opportunity is still live.'
  }, {
    question: 'What happens if a risk cannot be quoted online?',
    answer: 'Cases that require additional underwriting can be referred for review, so more complex opportunities can still be considered.'
  }, {
    question: 'Can my clients quote and buy online?',
    answer: 'Yes. Eligible clients can receive a quote and purchase cover through a digital Quote & Buy journey.'
  }, {
    question: 'How much commission can I earn?',
    answer: 'You can earn commission on eligible business placed through the platform. Your agreed commission structure will be confirmed as part of your onboarding.'
  }, {
    question: 'What types of businesses can I quote?',
    answer: 'The platform supports a broad range of commercial businesses and occupations. Available products and appetite will be shown within the platform.'
  }]
};
/** Locale key of the default intro copy inside the `page` namespace of each language under libs/uikit/src/locales */

var PORTAL_INTRO_DEFAULT_CONTENT_KEY = 'subBrokerPortalDefaultContent';
/** Picks the localized string when present, otherwise keeps the default English copy */

var pickLocalizedText = function pickLocalizedText(localized, fallback) {
  return typeof localized === 'string' && localized ? localized : fallback;
};
/**
 * Merges localized list items over the default items by index. Only the given
 * text keys are taken from the locale; non-translatable keys (icon names,
 * image/document urls, resource types) always come from the default config.
 */


var mergeLocalizedListItems = function mergeLocalizedListItems(defaultItems, localizedItems, textKeys) {
  return defaultItems.map(function (item, index) {
    var localizedItem = Array.isArray(localizedItems) ? localizedItems[index] : undefined;

    var merged = _objectSpread({}, item);

    textKeys.forEach(function (key) {
      merged[key] = pickLocalizedText(localizedItem === null || localizedItem === void 0 ? void 0 : localizedItem[key], item[key]);
    });
    return merged;
  });
};
/**
 * Resolves the default intro page copy for a country. Text is read from the
 * `page.subBrokerPortalDefaultContent` locale section of the country's language
 * (country -> locale follows supportTranslationCountryConvertMap), falling back
 * to English when the country or its translation is missing. Non-translatable
 * parts (brand name, images, icons, document urls) always come from
 * DEFAULT_PORTAL_INTRO_INFO.
 */


export var getDefaultPortalIntroInfo = function getDefaultPortalIntroInfo(countryCode) {
  var _get;

  var locale = countryCode && get(supportTranslationCountryConvertMap, [countryCode, 'locale']) || 'en';
  var localized = (_get = get(resources, [locale, 'page', PORTAL_INTRO_DEFAULT_CONTENT_KEY])) !== null && _get !== void 0 ? _get : get(resources, ['en', 'page', PORTAL_INTRO_DEFAULT_CONTENT_KEY]);

  if (!localized) {
    return DEFAULT_PORTAL_INTRO_INFO;
  }

  return _objectSpread(_objectSpread({}, DEFAULT_PORTAL_INTRO_INFO), {}, {
    heroTitle: pickLocalizedText(localized.heroTitle, DEFAULT_PORTAL_INTRO_INFO.heroTitle),
    heroSubtitle: pickLocalizedText(localized.heroSubtitle, DEFAULT_PORTAL_INTRO_INFO.heroSubtitle),
    heroChecklist: Array.isArray(localized.heroChecklist) ? localized.heroChecklist.map(function (text, index) {
      var _DEFAULT_PORTAL_INTRO;

      return pickLocalizedText(text, (_DEFAULT_PORTAL_INTRO = DEFAULT_PORTAL_INTRO_INFO.heroChecklist[index]) !== null && _DEFAULT_PORTAL_INTRO !== void 0 ? _DEFAULT_PORTAL_INTRO : '');
    }) : DEFAULT_PORTAL_INTRO_INFO.heroChecklist,
    coverageTitle: pickLocalizedText(localized.coverageTitle, DEFAULT_PORTAL_INTRO_INFO.coverageTitle),
    coverageSubtitle: pickLocalizedText(localized.coverageSubtitle, DEFAULT_PORTAL_INTRO_INFO.coverageSubtitle),
    coverageItems: mergeLocalizedListItems(DEFAULT_PORTAL_INTRO_INFO.coverageItems, localized.coverageItems, ['title', 'desc']),
    expertiseTitle: pickLocalizedText(localized.expertiseTitle, DEFAULT_PORTAL_INTRO_INFO.expertiseTitle),
    expertiseChips: mergeLocalizedListItems(DEFAULT_PORTAL_INTRO_INFO.expertiseChips, localized.expertiseChips, ['text']),
    portalTitle: pickLocalizedText(localized.portalTitle, DEFAULT_PORTAL_INTRO_INFO.portalTitle),
    portalFeatures: mergeLocalizedListItems(DEFAULT_PORTAL_INTRO_INFO.portalFeatures, localized.portalFeatures, ['title', 'desc']),
    advantageTitle: pickLocalizedText(localized.advantageTitle, DEFAULT_PORTAL_INTRO_INFO.advantageTitle),
    advantageItems: mergeLocalizedListItems(DEFAULT_PORTAL_INTRO_INFO.advantageItems, localized.advantageItems, ['title', 'desc']),
    ctaTitle: pickLocalizedText(localized.ctaTitle, DEFAULT_PORTAL_INTRO_INFO.ctaTitle),
    ctaSubtitle: pickLocalizedText(localized.ctaSubtitle, DEFAULT_PORTAL_INTRO_INFO.ctaSubtitle),
    resourcesTitle: pickLocalizedText(localized.resourcesTitle, DEFAULT_PORTAL_INTRO_INFO.resourcesTitle),
    resourcesSubtitle: pickLocalizedText(localized.resourcesSubtitle, DEFAULT_PORTAL_INTRO_INFO.resourcesSubtitle),
    resourceItems: mergeLocalizedListItems(DEFAULT_PORTAL_INTRO_INFO.resourceItems, localized.resourceItems, ['title']),
    faqTitle: pickLocalizedText(localized.faqTitle, DEFAULT_PORTAL_INTRO_INFO.faqTitle),
    faqItems: mergeLocalizedListItems(DEFAULT_PORTAL_INTRO_INFO.faqItems, localized.faqItems, ['question', 'answer'])
  });
};